import React, { Component } from 'react';
import {BrowserRouter} from 'react-router-dom';
import {Routes, Route} from 'react-router';

import Home from './Home.js';
import Projects from './Projects.js';
import {CtfIndex, Writeups, MyProblems} from './Ctfs.js';

import './style.css'

class App extends Component {
	render() {
    	return (
			<div className="App">
			<link href="https://fonts.googleapis.com/css?family=Orbitron|Nunito" rel="stylesheet"/>
			<BrowserRouter>
				<Routes>
					<Route exact path="/" element={<Home/>}/>
					<Route exact path="/projects" element={<Projects/>}/>
					<Route exact path="/ctf" element={<CtfIndex/>}/>
					<Route exact path="/ctf/writeups" element={<Writeups/>}/>
					<Route exact path="/ctf/problems" element={<MyProblems/>}/>
				</Routes>
			</BrowserRouter>
			<footer style={{height:"10em"}}>
			</footer>
			<div style={{textAlign:"center"}}>
				Copyright © 2024 Brandon Wong
			</div>
  		   	</div>
    	);
  	}
}

export default App;
